<template>
  <div class="page-header-warpper">
    <div class="page-header__content" @click="back">
      <div class="icon">
        <img src="@/assets/img/back.svg" alt="" />
      </div>
      <div class="title">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "返回",
    },
  },
  data() {
    return {};
  },
  methods: {
    back() {
      console.log(123);
      this.$emit("back");
    },
  },
};
</script>

<style lang="less" scoped>
.page-header-warpper {
  width: 100%;
  height: 45px;
  line-height: 45px;
  padding-left: 24px;
  box-sizing: border-box;
  border: 1px solid rgb(235, 237, 240);
  .page-header__content {
    width: 20%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .icon {
      img {
        width: 30px;
        height: 20px;
      }
    }
    .title {
      font-size: 14px;
      color: #000;
      font-weight: bold;
    }
  }
}
</style>
